interface NumberStepperProps {
  ariaLabel: string
  decrementLabel: string
  incrementLabel: string
  value: number
  min: number
  max: number
  step?: number
  onChange: (value: number) => void
  disabled?: boolean
  id?: string
  className?: string
}

function clamp(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, value))
}

export function NumberStepper({
  ariaLabel,
  decrementLabel,
  incrementLabel,
  value,
  min,
  max,
  step = 1,
  onChange,
  disabled = false,
  id,
  className = '',
}: NumberStepperProps) {
  const safeMin = Math.min(min, max)
  const safeMax = Math.max(min, max)
  const safeStep = Math.max(1, step)
  const boundedValue = clamp(value, safeMin, safeMax)
  const update = (nextValue: number) => onChange(clamp(nextValue, safeMin, safeMax))

  return (
    <div className={`number-stepper${className ? ` ${className}` : ''}`} role="group" aria-label={ariaLabel}>
      <button
        className="btn btn-ghost btn-square number-stepper__button"
        type="button"
        aria-label={decrementLabel}
        disabled={disabled || boundedValue <= safeMin}
        onClick={() => update(boundedValue - safeStep)}
      >
        <span aria-hidden="true">−</span>
      </button>
      <input
        id={id}
        className="input number-stepper__input"
        type="number"
        inputMode="numeric"
        min={safeMin}
        max={safeMax}
        step={safeStep}
        value={boundedValue}
        disabled={disabled}
        aria-label={ariaLabel}
        onChange={(event) => {
          const nextValue = Number(event.target.value)
          if (Number.isFinite(nextValue)) update(nextValue)
        }}
      />
      <button
        className="btn btn-ghost btn-square number-stepper__button"
        type="button"
        aria-label={incrementLabel}
        disabled={disabled || boundedValue >= safeMax}
        onClick={() => update(boundedValue + safeStep)}
      >
        <span aria-hidden="true">+</span>
      </button>
    </div>
  )
}
